import React, { useEffect, useState,Fragment }  from 'react';

import { isEmpty } from "lodash"

import Spin from '../../../commonModules/interface/Spin';
import { CardLayout, BreadCrumb } from './containers/Layout';
import SinglePurchase from './transfers/purchases/SingleTransferPurchase.jsx';
import Form from './arrivage/Form.jsx';
import FormP from './purchases/Form.jsx';
import ListPurchaseItem from './purchases/ListPurchaseItem.jsx';
import SingleShop from './shops/SingleShop';
import { Button, Box, IconButton } from '@material-ui/core';
import { AddCircleOutlineRounded, ListAltRounded, ListRounded } from '@material-ui/icons';
import CardPage from '../../../commonModules/layouts/CardPage';
import ListArrivage from './arrivage/ListArrivage';
import SingleArrivage from './arrivage/SingleArrivage';
import { connect } from 'react-redux';

import ListTransferArrivage from './transfers/arrivages/ListTransferArrivage';
import SingleTransferArrivage from './transfers/arrivages/SingleTransferArrivage';
import { toast } from 'react-toastify';


//class Arrivages extends Component{
const Arrivages = (props) => {
    const [state, setState] = useState({        
        view: props.new ? "new" : "list",
        listview: "purchase",

        singleShop:{},
        singlePurchase:{
            purchase:{},
            shop:{},
        },

        breadcrumb: "",
        mdpAdmin:'',

        selectSearch:"",
        selectSearchDisplay:{
            value:"",
            label:"Tous les Magasins",
        },
        pageOfItems:[],
        pageOfItemsProd:[],
        currentPage: 0,
        currentPageProd: 0,
        rowsPerPage: 20,
        singleArrivage: {
            products: []
        },
        errors: { // for purchase form
            product_id: "",
            quantity:"",
            price: ""
        }
    })    
        
    // CLEAR & DISPLAY
        const handleClose = () => {// close all dialog and singles
            setState(prevState => ({...prevState,
                view: "list",
                breadcrumb: "",
                singleArrivage: {
                    products: []
                },
                errors: { // for purchase form
                    product_id: "",
                    quantity:"",
                    price: ""
                }
            }));
        }
        const handleSingleArrivage = (purchase, shop) => {// open single shop page
            console.log('================SINGLE ARRIVAGE====================');
            console.log({purchase, shop});
            console.log('====================================');
            setState(prevState => ({...prevState,
                breadcrumb: `${purchase.nature} n°${purchase.id}`,
                singlePurchase:{
                    shop,
                    purchase
                },
                view: "purchase"
            }))
        }
        
        const handleCompleteArrivage =  async (arrivage, shop) => {
            console.log("handleCompleteArrivage ")   
            console.log("handleCompleteArrivage arrivage",{arrivage})   
            // toast.error("handleCompleteArrivage not implpemented")      
            // return;
            let errors = []            
            let purchase = {
                id: arrivage.id,
                shop: shop.id,
                shopDisplay: {label: shop.name, value:shop.id},
                nature: "achat",
                total: 0,
                totalHT: 0,
                transport: "",
                taxes: "",
                received: false,
                transfer_files_req: null,
                products: []
            }
            //Get Product from Transfert ID
            try {
                
                 const trsf = await props.fetchTransferDetails(arrivage.id);
                console.log("handleCompleteArrivage arrivage",{trsf})   


                trsf.products.forEach((prod, i) => {
                    // purchase.products[i].display = {value:prod.produid, label:`${prod.marque} - ${prod.name}`, disabled:true}
                    purchase.products[i] = {
                        product_id: prod.product_id,
                        quantity: parseInt(prod.quantity),
                        price: ""
                    }
                    errors[i]= {
                        product_id: "",
                        quantity:"",
                        price: ""
                    }
                });
                setState(prevState => ({...prevState,view: "complete", breadcrumb:"Compléter", singleArrivage: purchase, errors }))

            } catch (error) {
                console.error('Error fetching transfer details:', error);
                toast.error("ERROR Fetching previous data"+error.message)
            }

        }
        const handleUpdateArrivage = async (arrivage, shop) => {   
            console.log("handleUpdateArrivage ")   
            //toast.error("handleUpdateArrivage not implpemented")      
            arrivage.shopDisplay = {label: shop.name, value: shop.id}
            arrivage.shop = shop.id
            arrivage.products =[]
            try {
                
                const trsf = await props.fetchTransferDetails(arrivage.id);
               console.log("handleCompleteArrivage arrivage",{trsf})   
               trsf.products.forEach((prod, i) => {
                   // purchase.products[i].display = {value:prod.produid, label:`${prod.marque} - ${prod.name}`, disabled:true}
                   arrivage.products[i] = {
                       product_id: prod.product_id,
                       quantity: parseInt(prod.quantity),
                       price: ""
                   }
               });
               setState(prevState => ({...prevState,view: "updateArrivage", breadcrumb:"Modifier l'arrivage", singleArrivage: arrivage  }))

           } catch (error) {
               console.error('Error fetching transfer details:', error);
               toast.error("ERROR Fetching previous data"+error.message)
           }
        }
        const handleUpdateDemand = async (arrivage, shop) => {   
            console.log("handleUpdateDemand ")   
            //toast.error("handleUpdateArrivage not implpemented")      
            arrivage.shopDisplay = {label: shop.name, value: shop.id}
            arrivage.shop = shop.id
            arrivage.products =[]
            try {
                
                const trsf = await props.fetchTransferDetails(arrivage.id);
               console.log("handleUpdateDemand arrivage",{trsf})   
               trsf.products.forEach((prod, i) => {
                   // purchase.products[i].display = {value:prod.produid, label:`${prod.marque} - ${prod.name}`, disabled:true}
                   arrivage.products[i] = {
                       product_id: prod.product_id,
                       quantity: parseInt(prod.quantity)                   }
               });
               setState(prevState => ({...prevState,view: "updateDemand", breadcrumb:"Modifier la demande", singleArrivage: arrivage  }))

           } catch (error) {
               console.error('Error fetching transfer details:', error);
               toast.error("ERROR Fetching previous data"+error.message)
           }
        }
        const handleSingleShop = (shop) => {// open single shop page
            setState(prevState => ({...prevState,
                breadcrumb: shop.name,
                singleShop: shop,
                view: "shop"
            }))
        }
        const onChangePage = (pageOfItems, page, rowsPerPage) => {
            setState(prevState => ({...prevState, pageOfItems, currentPage: page, rowsPerPage }));
        }
        const onChangePageProd = (pageOfItemsProd, page, rowsPerPage) => {
            setState(prevState => ({...prevState,  pageOfItemsProd, currentPageProd: page, rowsPerPage }));
        }
        const handleOpenForm = (view, breadcrumb) => {
            setState(prevState => ({...prevState, view, breadcrumb}))
        }
        const handleOpenFormUpdate = (view, breadcrumb) => {
            setState(prevState => ({...prevState, view, breadcrumb}))
        }
       
        return(
            <CardPage title="Arrivages et Demandes" storehouse action={
                <Box>
                    {state.view === "list" && 
                        <Fragment>
                            <Box p={1}>
                                <Button color="primary" variant="contained"
                                    startIcon={<AddCircleOutlineRounded />}
                                    onClick={ () =>
                                        setState(prevState => ({...prevState,view: "new", breadcrumb:"Nouvel Arrivage" }))
                                    }
                                >
                                    Arrivage 
                                </Button>
                            </Box>
                            <Box p={1}>
                                <Button color="primary" variant="contained"
                                    startIcon={<AddCircleOutlineRounded />}
                                    onClick={ () =>
                                        setState(prevState => ({...prevState,view: "newDemand", breadcrumb:"Nouvelle demande d'achat" }))
                                    }
                                >
                                    Demande 
                                </Button>
                            </Box>
                            {/* {this.state.listview === "purchase" &&
                                <IconButton 
                                    color="secondary"
                                    title="Vue Produits"
                                    onClick={()=>
                                        this.setState({ view: "list", listview: "prodList" })
                                    }>
                                    <ListRounded />
                                </IconButton> 
                            } 
                            {this.state.listview === "prodList" &&
                            <IconButton 
                                color="secondary" 
                                title="Vue Arrivages"
                                onClick={()=>
                                    this.setState({ view: "list", listview: "purchase" })
                                }>
                                <ListAltRounded />
                            </IconButton> 
                            }  */}
                        </Fragment>
                    }
                </Box>
            }>
                <BreadCrumb 
                    breadcrumb={ state.breadcrumb } 
                    title="Arrivages" 
                    back={handleClose} 
                />

                {(props.STATE.arrivages.fetching || props.STATE.demands.fetching) && 
                    <Spin noOverlay/>
                }
                
                {state.view === "shop" &&
                   <SingleShop shop={state.singleShop} {...props} />
                }       
                {state.view === "new" &&
                    <Form 
                        {...props}
                        handleClose={handleClose}
                    />
                }
                {state.view === "newDemand" &&
                    <Form 
                        {...props}
                        demand
                        handleClose={handleClose}
                    />
                }
                {state.view === "updateDemand" &&
                    <Form 
                        {...props}
                        demand
                        update
                        arrivage={state.singleArrivage} 
                        arrivageOLD={state.singleArrivage} 
                        handleClose={handleClose}
                    />
                }
                {state.view === "updateArrivage" &&
                    <Form 
                        {...props}
                        update
                        arrivage={state.singleArrivage} 
                        arrivageOLD={state.singleArrivage} 
                        handleClose={handleClose}
                    />
                }
                {state.view === "purchase" &&
                    <SingleTransferArrivage
                        {...props}
                        transfer={state.singlePurchase.purchase} 
                        shop={state.singlePurchase.shop} 
                        handleCompleteArrivage={handleCompleteArrivage}  
                        handleUpdateArrivage={handleUpdateArrivage}  
                        handleUpdateDemand={handleUpdateDemand}
                    />
                }
                {state.view === "complete" &&
                    <FormP
                        {...props}
                        arrivage={state.singleArrivage} 
                        errors={state.errors} 
                        handleClose={handleClose}                        
                    />
                }

                {state.view === "list" && state.listview === "purchase" &&
                <Box>
                    {/* {(!isEmpty(this.props.ARRIVAGES) || !isEmpty(this.props.DEMANDS))&& */}
                        <ListTransferArrivage
                            {...props}
                            {...state}
                            handleOpenForm={handleOpenForm}
                            onChangePage={onChangePage}
                            handleSingleShop={handleSingleShop}  
                            handleSingleArrivage={handleSingleArrivage}  
                            handleCompleteArrivage={handleCompleteArrivage}  
                            handleUpdateArrivage={handleUpdateArrivage}  
                            handleUpdateDemand={handleUpdateDemand}
                        />
                    {/* } */}
                </Box>
                }
                {/* {this.state.view === "list" && this.state.listview === "prodList" &&
                <Box>
                    {!isEmpty(this.props.PURCHASES) &&
                        <ListPurchaseItem
                            {...this.props}
                            {...this.state}
                            onChangePage={this.onChangePageProd}
                            handleSingleShop={this.handleSingleShop}  
                            handleSingleArrivage={this.handleSingleArrivage}  
                            notif={this.notif}  
                        />
                    }
                </Box>
                } */}
            </CardPage>
        )
}

export default Arrivages
// const mapDispatchToProps = {
//     fetchTransferDetails,
//   };
  
// export default connect(null, mapDispatchToProps)(Arrivages);